import Entities from './Entities'

export default ({ getUsers, addUser, setWriteAccess, removeUser }) ->
  Entities({
    addEntity: addUser
    allEntities: Weaver.User.list
    entityFilter: (value, user) ->
      "#{user.firstname} #{user.lastname}".toLowerCase().includes(value.toLowerCase()) or
        user.username.toLowerCase().includes(value.toLowerCase())
    comparator: 'userId'
    sortBy: ['firstname', 'lastname']
    getEntities: getUsers
    refreshOnFocus: true
    removeEntity: removeUser
    setWriteAccess: setWriteAccess
    title: 'users'
    titleRenderer: ({ firstname, lastname }) -> "#{ firstname } #{ lastname }"
  })
